import { UserRolesFormValues } from './types';

export const mapUserRolesToUserRolesFormValues = (
    userRoles: number[]
): UserRolesFormValues => {
    return userRoles.reduce((result, roleId) => {
        result[roleId] = true;
        return result;
    }, {});
};
